const nourishmentData =
{
  "vitamin-a-kids-4": {
    "weight": 0.8,
    "labelWeight": "800mcg",
    "NRV": "100%",
    "ingredient": "Vitamin A Acetate",
    "sanitisedName": "Vitamin A",
  },
  "vitamin-a-kids-9": {
    "weight": 1.6,
    "labelWeight": "1600mcg",
    "NRV": "200%",
    "ingredient": "Vitamin A Acetate",
    "sanitisedName": "Vitamin A",
  },
  "vitamin-e-kids-4": {
    "weight": 12,
    "labelWeight": "12mg",
    "NRV": "100%",
    "ingredient": "Vitamin E (DL - Alpha Tocopheryl) Acetate",
    "sanitisedName": "Vitamin E",
  },
  "vitamin-e-kids-9": {
    "weight": 24,
    "labelWeight": "24mg",
    "NRV": "200%",
    "ingredient": "Vitamin E (DL - Alpha Tocopheryl) Acetate",
    "sanitisedName": "Vitamin E",
  },
  "iron-kids-4": {
    "weight": 6,
    "labelWeight": "6mg",
    "NRV": "43%",
    "ingredient": "Ferrous Citrate",
    "sanitisedName": "Iron",
  },
  "iron-kids-9": {
    "weight": 12,
    "labelWeight": "12mg",
    "NRV": "85%",
    "ingredient": "Ferrous Citrate",
    "sanitisedName": "Iron",
  },
  "zinc-kids-4": {
    "weight": 5,
    "labelWeight": "5mg",
    "NRV": "50%",
    "ingredient": "Zinc Citrate",
    "sanitisedName": "Zinc",
  },
  "zinc-kids-9": {
    "weight": 10,
    "labelWeight": "10mg",
    "NRV": "100%",
    "ingredient": "Zinc Citrate",
    "sanitisedName": "Zinc",
  },
  "folic-acid-kids-4": {
    "weight": 0.2,
    "labelWeight": "200mcg",
    "NRV": "100%",
    "ingredient": "Folic acid (B9)",
    "sanitisedName": "Folic acid",
  },
  "folic-acid-kids-9": {
    "weight": 0.4,
    "labelWeight": "400mcg",
    "NRV": "200%",
    "ingredient": "Folic acid (B9)",
    "sanitisedName": "Folic acid",
  },
  "vitamin-d3-kids-4": {
    "weight": 3.75,
    "labelWeight": "150IU",
    "NRV": "75%",
    "ingredient": "Vita-algae D3",
    "sanitisedName": "Vitamin D3",
  },
  "vitamin-d3-kids-9": {
    "weight": 7.5,
    "labelWeight": "300IU",
    "NRV": "150%",
    "ingredient": "Vita-algae D3",
    "sanitisedName": "Vitamin D3",
  },
  "coq10-kids-4": {
    "weight": 15,
    "labelWeight": "15mg",
    "NRV": "N/A",
    "ingredient": "COQ10",
    "sanitisedName": "CoQ10",
  },
  "coq10-kids-9": {
    "weight": 30,
    "labelWeight": "30mg",
    "NRV": "N/A",
    "ingredient": "COQ10",
    "sanitisedName": "CoQ10",
  },
  "b12-kids-4": {
    "weight": 0.001875,
    "labelWeight": "1.875 mcg",
    "NRV": "75%",
    "ingredient": "Vitamin B12",
    "sanitisedName": "Vitamin B12",
  },
  "b12-kids-9": {
    "weight": 0.00375,
    "labelWeight": "3.75 mcg",
    "NRV": "150%",
    "ingredient": "Vitamin B12",
    "sanitisedName": "Vitamin B12",
  },
  "vitamin-c-kids-4": {
    "weight": 48,
    "labelWeight": "48mg",
    "NRV": "60%",
    "ingredient": "Vitamin C",
    "sanitisedName": "Vitamin C",
  },
  "vitamin-c-kids-9": {
    "weight": 96,
    "labelWeight": "96mg",
    "NRV": "120%",
    "ingredient": "Vitamin C",
    "sanitisedName": "Vitamin C",
  },
  "silica-kids": {
    "weight": 100,
    "labelWeight": "100 mg",
    "NRV": "N/A",
    "ingredient": "Silica (Bamboo extract)",
    "sanitisedName": "Silica",
  },
  "selenium-kids": {
    "weight": 0.055,
    "labelWeight": "55 mcg",
    "NRV": "100%",
    "ingredient": "Selenium Yeast",
    "sanitisedName": "Selenium Yeast",
  },
  "lactospore-probiotic-kids": {
    "weight": 17.33,
    "labelWeight": "200 Million CFU",
    "NRV": "N/A",
    "ingredient": "Lactospore Probiotic",
    "sanitisedName": "Lactospore Probiotic",
  },
  "beta-glucan-kids": {
    "weight": 50,
    "labelWeight": "50mg",
    "NRV": "N/A",
    "ingredient": "Beta Glucan",
    "sanitisedName": "Beta Glucan",
  },
  "k2-vital-delta-kids-4": {
    "weight": 0.0375,
    "labelWeight": "37.5 mcg",
    "NRV": "50%",
    "ingredient": "K2 Vital Delta",
    "sanitisedName": "K2 Vital Delta",
  },
  "k2-vital-delta-kids-9": {
    "weight": 0.075,
    "labelWeight": "75 mcg",
    "NRV": "100%",
    "ingredient": "K2 Vital Delta",
    "sanitisedName": "K2 Vital Delta",
  },
  "beetroot-kids": {
    "weight": 100,
    "labelWeight": "100mg",
    "NRV": "N/A",
    "ingredient": "Beetroot powder",
    "sanitisedName": "Beetroot",
  },
  "lycopene-kids": {
    "weight": 100,
    "labelWeight": "10mg",
    "NRV": "N/A",
    "ingredient": "Lycopene Extract",
    "sanitisedName": "Lycopene",
  },
  "maca-powder-kids": {
    "weight": 50,
    "labelWeight": "50 mg",
    "NRV": "N/A",
    "ingredient": "Maca Root Powder",
    "sanitisedName": "Maca Powder",
  },
  "tart-cherry-kids": {
    "weight": 100,
    "labelWeight": "100mg",
    "NRV": "N/A",
    "ingredient": "Montmorency Cherry",
    "sanitisedName": "Tart Cherry Extract",
  },
  "ginger-kids": {
    "weight": 100,
    "labelWeight": "100mg",
    "NRV": "N/A",
    "ingredient": "Ginger (5% gingerols)",
    "sanitisedName": "Ginger extract",
  },
  "hydrocurc-pepperine-kids": {
    "weight": 96,
    "labelWeight": "96mg",
    "NRV": "N/A",
    "ingredient": "Hydrocurc Curcurmin (standardised to contain min 85% curcminoids), Black pepper extract",
    "sanitisedName": "HydroCurc™ & Black Pepper Extract",
  },
  "scutellup-kids": {
    "weight": 20,
    "labelWeight": "20mg",
    "NRV": "N/A",
    "ingredient": "Scutell'up",
    "sanitisedName": "Scutell'up",
  },
}

export default nourishmentData;
